import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconExclamationMarkTriangle24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconExclamationMarkTriangle24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.404 5.033c-1.048-1.886-3.76-1.886-4.808 0L2.995 16.914C1.977 18.747 3.302 21 5.399 21h13.202c2.097 0 3.422-2.253 2.404-4.086zm-3.497.728a1.25 1.25 0 0 1 2.186 0l6.6 11.882a1.25 1.25 0 0 1-1.092 1.857H5.399a1.25 1.25 0 0 1-1.093-1.857zm.343 7.989v-4.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 1 1-1.5 0m2 3.497a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconExclamationMarkTriangle24);
